import { render, staticRenderFns } from "./PodcastLinkIcons.vue?vue&type=template&id=c1b9aefa&scoped=true&"
import script from "./PodcastLinkIcons.vue?vue&type=script&lang=js&"
export * from "./PodcastLinkIcons.vue?vue&type=script&lang=js&"
import style0 from "./PodcastLinkIcons.vue?vue&type=style&index=0&id=c1b9aefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b9aefa",
  null
  
)

export default component.exports